// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3PUI9","buttons":"PendingPaymentAlert_buttons__1JBft"};